module.exports = __webpack_public_path__ + "img/icon-bell.fa3ce975.svg";